import {useDispatch} from "react-redux";
import {useHttp} from "./useHttp";
import {createSetPartOrderData} from "../actions/dataActions";


export const usePartOrderData = (id, dataFresh) => {
    let noFetch = !id
    const dispatch = useDispatch();
    const [data, loading, error] = useHttp(
        `partorder/${id}`,
        "get",
        {},
        dataFresh,
        noFetch
    );
    if(error){
        throw Error("There was an error getting part order data");
    }
    if(!loading && data !== null){
        dispatch(createSetPartOrderData(data));
    } else {
        dispatch(createSetPartOrderData({
            customer: {},
            customer_vehicle : "",
            customer_vehicle_vin: "",
            parts: [],
            status: "ORDER",
            description: "",
            department: {name:"VAN PARTS DIRECT", id:9},
            cash_sale: []
        }))
    }

    return !loading
}